import type addAnchorListener from '@helpers/addAnchorListener';
import {PHONE_NUMBER_REG_EXP} from '.';
import {MOUNT_CLASS_TO} from '@config/debug';
import matchUrlProtocol from '@lib/richTextProcessor/matchUrlProtocol';
import {T_ME_PREFIXES} from '@appManagers/constants';

export default function wrapUrl(url: string, safe?: boolean) {
  if(!matchUrlProtocol(url)) {
    url = 'https://' + url;
  }

  const out: {url: string, onclick?: Parameters<typeof addAnchorListener>[0]['name']} = {url};
  let tgMeMatch, ownMeMatch, telescoPeMatch, tgMatch;
  let onclick: typeof out['onclick'];
  /* if(unsafe === 2) {
    url = 'tg://unsafe_url?url=' + encodeURIComponent(url);
  } else */
  if((ownMeMatch = url.match(/^(https?:\/\/)?([a-z0-9-]+\.)*(?:web\.strada\.pp\.ua|stradagram\.pp\.ua|s-g\.pp\.ua|web\.roxera\.net)(?:\/(.+))?(?:\?(?:[^#]*))?$/i))) {
    const u = new URL(url);
    const fullPath = u.pathname.slice(1);
    const path = fullPath.split('/');

    if(path[0] && path[0][0] === '$') {
      onclick = 'invoice';
    } else if(/^\+/.test(fullPath)) { // s-g.lol/+380..., s-g.lol/+hash
      onclick = path[0].length === 1 ? 'joinchat' : PHONE_NUMBER_REG_EXP.test(fullPath) ? 'im' : 'joinchat';
    } else if(path[0]) switch(path[0]) {
      case 'addlist':
      case 'addstickers':
      case 'addemoji':
      case 'invoice':
      case 'giftcode':
      case 'nft':
      case 'addstyle':
        if(path.length === 2) {
          onclick = path[0];
          break;
        }
        break;
      default:
        if(path[0] === 'c' || path[0].match(/^[a-zA-Z][a-zA-Z0-9_]{2,31}$/)) {
          onclick = 'im';
          break;
        }
        break;
    }
  }

  if((tgMeMatch = url.match(/^(?:https?:\/\/)?(?:(.+?)\.)?(?:(?:web|k|z|a)\.)?t(?:elegram)?\.me(?:\/(.+))?/))) {
    const u = new URL(url);
    let prefix = tgMeMatch[1];
    if(prefix && T_ME_PREFIXES.has(tgMeMatch[1])) {
      prefix = undefined;
    }

    if(prefix) {
      u.pathname = prefix + (u.pathname === '/' ? '' : u.pathname);
    }

    const fullPath = u.pathname.slice(1);
    const path = fullPath.split('/');

    if(path[0] && path[0][0] === '$' && path[0].length > 1) {
      onclick = 'invoice';
    } else if(/^\+/.test(fullPath) && !PHONE_NUMBER_REG_EXP.test(fullPath)) { // second regexp is for phone numbers (t.me/+38050...)
      onclick = 'joinchat';
    } else if(path[0]) switch(path[0]) {
      case 'm':
      case 'addlist':
      case 'joinchat':
      case 'addstickers':
      case 'addemoji':
      case 'voicechat':
      case 'call':
      case 'invoice':
      case 'boost':
      case 'giftcode':
      case 'share':
      case 'nft':
      case 'addstyle':
        if(path.length !== 1 && !prefix) {
          onclick = path[0];
          break;
        }

      default:
        if(path.length <= 2 || path[1]?.match(/^\d+(?:\?(?:comment|thread)=\d+)?$/) || ['s', 'c', 'a'].includes(path[1])) {
          onclick = 'im';
          break;
        }

        break;
    }
  } else if((telescoPeMatch = url.match(/^(?:https?:\/\/)?telesco\.pe\/([^/?]+)\/(\d+)/))) {
    onclick = 'im';
  } else if((tgMatch = url.match(/tg:(?:\/\/)?(.+?)(?:\?|$)/))) {
    onclick = 'tg_' + tgMatch[1].split('/')[0] as any;

    switch(tgMatch[1]) {
      // * local
      case 'iv': {
        try {
          if(!safe) {
            throw 'unsafe';
          }

          out.url = decodeURIComponent(new URL(url).searchParams.get('url'));
        } catch(err) {
          onclick = undefined;
        }
        break;
      }
    }
  }/*  else if(!safe) {
    url = 'tg://unsafe_url?url=' + encodeURIComponent(url);
  } */

  if(!(window as any)[onclick]) {
    onclick = undefined;
  }

  out.onclick = onclick;
  return out;
}

MOUNT_CLASS_TO && (MOUNT_CLASS_TO.wrapUrl = wrapUrl);
